import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import EN from '../shared/Lenguages/en.json';
import IT from '../shared/Lenguages/it.json';
import FR from '../shared/Lenguages/fr.json';

i18n
  .use(initReactI18next) // collegamento a React
  .init({
    resources: {
      en: { translation: EN },
      it: { translation: IT },
      fr: { translation: FR },
    },
    lng: localStorage.getItem('i18nextLng') || 'it', // lingua di default
    fallbackLng: "en", // se manca la traduzione
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false, // Importante per evitare lag
    },
    keySeparator: ".", // perché usiamo chiavi tipo "pages.Home.benvenuto"
    format: (value, format, lng) => {
      if (value instanceof Date) {
        if (format === "date") {
          return new Intl.DateTimeFormat(lng, { day: "2-digit", month: "2-digit", year: "numeric" }).format(value);
        }
        if (format === "time") {
          return new Intl.DateTimeFormat(lng, { hour: "2-digit", minute: "2-digit" }).format(value);
        }
      }
      return value;
    }
  });

export default i18n;

// HH:mm nel testo API sono già orario "da salone", non timestamp UTC.
const DATE_RE = '(\\d{1,2}[-/]\\d{1,2}[-/]\\d{4})';
const TIME_RE = '(\\d{1,2}:\\d{2})';

const patterns = {
  // Varianti: "una prenotazione del" / "la prenotazione il|del", date D-M o DD-MM, "alle" / "alle ore"
  canceled: new RegExp(
    `^(.+?)\\s+ha disdetto (?:una prenotazione del|la prenotazione (?:il|del))\\s+${DATE_RE}\\s+alle(?:\\s+ore)?\\s+${TIME_RE}$`,
  ),
  newBooking: new RegExp(
    `^Hai una nuova prenotazione da\\s+(.+?)\\s+alle(?:\\s+ore)?\\s+${TIME_RE}\\s+del\\s+${DATE_RE}$`,
  ),
  noConfirm: new RegExp(
    `^Mancata conferma\\s*-\\s*(.+?)\\s+non ha confermato la prenotazione del\\s+${DATE_RE}\\s+alle(?:\\s+ore)?\\s+${TIME_RE}$`,
  ),
  noConfirmOld: new RegExp(
    `^Disdetta automatica\\s*-\\s*(.+?)\\s+non ha confermato la prenotazione del\\s+${DATE_RE}\\s+alle(?:\\s+ore)?\\s+${TIME_RE}$`,
  ),
};

const pad2Time = (timeStr) => {
  if (!timeStr) return timeStr;
  const [h, m] = String(timeStr).split(':');
  return `${String(h).padStart(2, '0')}:${String(m ?? '00').padStart(2, '0')}`;
};

const normalizeDateStr = (dateStr) => {
  if (!dateStr) return dateStr;
  const [d, m, y] = String(dateStr).split(/[-/]/);
  return `${String(d).padStart(2, '0')}/${String(m).padStart(2, '0')}/${y}`;
};

export function normalizeServerMessage(text) {
  if (typeof text !== 'string') {
    return { raw: '' };
  }

  let m = text.match(patterns.canceled);
  if (m) {
    const [, user, dateStr, timeStr] = m;
    return {
      key: 'booking.canceled_by_user',
      params: {
        user,
        date: normalizeDateStr(dateStr),
        time: pad2Time(timeStr),
      },
    };
  }

  m = text.match(patterns.newBooking);
  if (m) {
    const [, user, timeStr, dateStr] = m;
    return {
      key: 'booking.new',
      params: {
        user,
        date: normalizeDateStr(dateStr),
        time: pad2Time(timeStr),
      },
    };
  }

  m = text.match(patterns.noConfirm);
  if (m) {
    const [, user, dateStr, timeStr] = m;
    return {
      key: 'booking.no_confirm',
      params: {
        user,
        date: normalizeDateStr(dateStr),
        time: pad2Time(timeStr),
      },
    };
  }

  m = text.match(patterns.noConfirmOld);
  if (m) {
    const [, user, dateStr, timeStr] = m;
    return {
      key: 'booking.no_confirm',
      params: {
        user,
        date: normalizeDateStr(dateStr),
        time: pad2Time(timeStr),
      },
    };
  }

  return { raw: text };
}
